import { FormFieldTypes } from "../../../../../../../data/formFieldType";

const initialState = {
  EndDate: new Date(),
};

export const createRenewalConfig = {
  name: "Add Department",
  initialState: initialState,
  section: [
    {
      sectionId: "ContractRenewalSection",
      title: "Contract Renewal Section",
      row: {},
      style: {
        sectionStyle: "col-lg-12 col-md-12",
      },
      wrapperTemplate: <div className=""></div>,
      fields: [
        {
          id: "lPendingContractAgreementTemplateKey",
          label: "Agreement Template :",
          Field_Name: "lPendingContractAgreementTemplateKey",
          fieldType: FormFieldTypes.SELECT,
          dataField: "lPendingContractAgreementTemplateKey",
          fieldSetting: {
            isEnableOnChange: true,
            options: [],
          },
          validation: [{ type: "require" }],
          style: {
            containerCss: "col-xxl-12 col-lg-12 mb-2 pr-0",
          },
        },
        {
          id: "pdtEndDate",
          label: "Effective Date :",
          Field_Name: "Effective Date",
          fieldType: FormFieldTypes.DATEPICKER,
          dataField: "EndDate",
          fieldSetting: {
            placeholder: "To",
            subTitle: " ",
          },
          validation: [{ type: "require" }],
          style: {
            containerCss: "col-lg-12 col-md-4 col-4 mb-2 ",
          },
        },
        {
          id: "TermMonths",
          label: "Term Months :",
          Field_Name: "Term Months",
          fieldType: FormFieldTypes.INPUT,
          dataField: "poNumber",
          fieldSetting: {
            placeholder: "Term Months",
            isEnableOnChange: true,
          },
          validation: [{ type: "require" }],
          style: {
            containerCss: "col-xxl-12 col-lg-12 mb-2 pr-0",
          },
        },
      ],
    },
  ],
};
